import React from "react";
import { METRIC, IMPERIAL } from "../constants/units";
import { UPDATED_UNIT } from "../constants/actionTypes";
import { useUnit, useUnitDispatch } from "../context/UnitContext";
import { useSearch } from "../context/SearchContext";
import "../../css/WeatherTemperature.css";

export default function Units({ city }) {
  const unit = useUnit();
  const dispatch = useUnitDispatch();
  const search = useSearch();

  const showUnit = (event, unit) => {
    event.preventDefault();
    dispatch({ type: UPDATED_UNIT, unit });
    search(city, unit);
  };

  return unit === METRIC ? (
    <div className="unit">
      °C |{" "}
      <a
        href="/"
        onClick={(event) => showUnit(event, IMPERIAL)}
        className="text-decoration-none"
      >
        °F
      </a>
    </div>
  ) : (
    <div className="unit">
      <a
        href="/"
        onClick={(event) => showUnit(event, METRIC)}
        className="text-decoration-none"
      >
        °C
      </a>{" "}
      | °F
    </div>
  );
}
